import MainPage from "./Pages/MainPage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthModalPage from "./SharedComponents/AuthModalPage";
import AboutUs from "./SharedComponents/AboutUs";
import PlaceDetail from "./SharedComponents/PlaceDetail";
import ScrollToTop from "./SharedComponents/ScrollToTop";
import { ToastContainer } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import useUserStore from './store/userStore';
import { favoritesQueryKey } from "./hooks/useFavorites";
import SearchResultsPage from "./SharedComponents/SerachResultPage";
import AllPlacesByCategory from "./SharedComponents/AllPlacesByCategory";
import AllPlans from "./SharedComponents/AllPlans";
import PlanDetail from "./SharedComponents/PlanDetail";
import Layout from "./SharedComponents/Layout";
import Favorites from "./SharedComponents/Favorites";
import UserProfile from "./SharedComponents/UserProfile";
import CityPage from "./SharedComponents/CityPage";
import CitiesPage from "./SharedComponents/CitiesPage";
import WizardPage from "./Pages/WizardPage";
import AllUserReviewsPage from "./Pages/AllUserReviewsPage";
import AnalyticsTracker from "./SharedComponents/AnalyticsTracker";
// import MobileBottomNavigation from "./SharedComponents/MobileBottomNavigation";

function App() {
  const queryClient = useQueryClient();
  const userId = useUserStore((state) => state.user?.userId);
  const previousUserId = useRef<string | undefined>(userId);

  useEffect(() => {
    if (previousUserId.current && previousUserId.current !== userId) {
      queryClient.removeQueries({
        queryKey: favoritesQueryKey(previousUserId.current),
        exact: true,
      });
    }

    previousUserId.current = userId;
  }, [queryClient, userId]);


  return (
    <div className="App font-myYekanRegular" dir="rtl">
      <BrowserRouter>
        <AnalyticsTracker />
        <ScrollToTop />
        <div>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<MainPage />} />
              <Route path="/userProfile" element={<UserProfile />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/places/:id" element={<PlaceDetail />} />
              <Route path="/plans/:id" element={<PlanDetail />} />
              <Route path="/search-results" element={<SearchResultsPage />} />
              <Route path="/places/category/:category" element={<AllPlacesByCategory />} />
              <Route path="/plans" element={<AllPlans />} />
              <Route path="/planner" element={<WizardPage />} />
              <Route path="/signUp" element={<AuthModalPage initialMode="signup" />} />
              <Route path="/login" element={<AuthModalPage initialMode="login" />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/places/city/:city" element={<CityPage />} />
              <Route path="/destinations" element={<CitiesPage />} />
              <Route path="/reviews" element={<AllUserReviewsPage />} />
            </Route>
          </Routes>
        </div>
        {/* <MobileBottomNavigation /> */}
        <ToastContainer position="top-center" closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
